// extracted by mini-css-extract-plugin
export default {"radarNumberModal":"radarNumberModal_radarNumberModal__tdWpR","treeBox":"radarNumberModal_treeBox__WfM3O"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"radarNumberModal\":\"radarNumberModal_radarNumberModal__tdWpR\",\"treeBox\":\"radarNumberModal_treeBox__WfM3O\"}";
        // 1793842506733
        var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  